import { useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";

export default function PaymentResult() {
    const [sp] = useSearchParams();
    const ref = sp.get("ref");
    return (
        <main className="pt-40 pb-40 min-h-screen" data-testid="payment-result">
            <div className="mx-auto max-w-3xl px-6 text-center">
                <div className="w-16 h-16 mx-auto border border-[color:var(--gold)] rounded-full flex items-center justify-center">
                    <Check className="text-[color:var(--gold)]" strokeWidth={1.25} />
                </div>
                <p className="eyebrow mt-8">Thank you</p>
                <h1 className="font-display text-6xl md:text-8xl mt-4">We've got you.</h1>
                <p className="mt-8 text-[color:var(--cream-muted)]">Your transaction was received. A confirmation email is on its way.</p>
                {ref && <p className="mt-4 text-xs text-[color:var(--cream-muted)]">Reference: {ref}</p>}
                <div className="mt-12"><Link to="/" className="btn-gold btn-gold-solid">Return home</Link></div>
            </div>
        </main>
    );
}
